import React, { PropsWithChildren } from "react";
import styled from "@emotion/styled";
import { css } from "@emotion/react";
import { PanelGroupContext } from ".";

interface ITabItemStyledProps {
  isActive?: boolean;
}
const TabItemStyled = styled.div<ITabItemStyledProps>`
  font-size: 11px;
  font-weight: bold;
  padding: 9px 12px;
  float: left;
  position: relative;
  border-left: 1px solid transparent;
  border-right: 1px solid transparent;
  color: var(--builder-tabs-inactive-color);
  min-width: 60px;
  text-align: center;
  :hover {
    cursor: pointer;
  }

  // style for active tab
  ${(props) =>
    props.isActive &&
    css`
      background: var(--builder-panel-background);
      border-radius: 2px 2px 0 0;
      color: var(--builder-text-color);
      ::before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: linear-gradient(rgb(255 255 255 / 4%), transparent);
        z-index: -1;
      }
    `}
`;

export interface ITabItemProps {
  tabKey: string;
  onClick?: () => void;
}

export const TabItem: React.FC<PropsWithChildren<ITabItemProps>> = ({
  tabKey,
  children,
  onClick,
}) => {
  const { activeKey, onTabSelect } = React.useContext(PanelGroupContext);
  return (
    <TabItemStyled
      isActive={tabKey == activeKey}
      onClick={(e) => {
        onTabSelect?.(tabKey, e);
        onClick?.();
      }}
    >
      {children}
    </TabItemStyled>
  );
};
